export const PG = {
  black: '#000000',
  surface: '#0A0A0A',
  surfaceElev: '#111111',
  borderDim: '#1A1A1A',
  borderMid: '#2A2A2A',
  borderHi: '#3A3A3A',
  white: '#FFFFFF',
  neutral300: '#D4D4D4',
  neutral400: '#A3A3A3',
  neutral500: '#737373',
  neutral600: '#525252',
  neutral700: '#404040',
  red: '#D71921',
  redDim: '#7A0E13',
  amber: '#FFB800',
  emerald: '#00C27A',
  green: '#00FF41',
  cyan: '#00D4FF',
  violet: '#A060FF',
};

export const FONTS = {
  display: "'Doto', sans-serif",
  mono: "'Space Mono', monospace",
  body: "'Space Grotesk', sans-serif",
};

export const STATUS_COLOR = {
  ON_TRACK: PG.emerald,
  WARNING: PG.amber,
  BREACHED: PG.red,
};

export const echartsTheme = {
  backgroundColor: 'transparent',
  textStyle: {
    fontFamily: 'Space Mono, monospace',
    color: PG.neutral300,
  },
  title: {
    textStyle: { color: PG.white, fontFamily: 'Space Grotesk, sans-serif', fontWeight: 700 },
    subtextStyle: { color: PG.neutral500 },
  },
  line: {
    itemStyle: { borderWidth: 2 },
    lineStyle: { width: 2 },
    symbolSize: 6,
    symbol: 'circle',
    smooth: false,
  },
  bar: { itemStyle: { barBorderWidth: 0 } },
  categoryAxis: {
    axisLine: { show: true, lineStyle: { color: PG.borderMid } },
    axisTick: { show: false },
    axisLabel: { show: true, color: PG.neutral500, fontFamily: 'Space Mono, monospace', fontSize: 10 },
    splitLine: { show: false },
  },
  valueAxis: {
    axisLine: { show: false },
    axisTick: { show: false },
    axisLabel: { show: true, color: PG.neutral500, fontFamily: 'Space Mono, monospace', fontSize: 10 },
    splitLine: { show: true, lineStyle: { color: PG.borderDim, type: 'dashed' } },
  },
  legend: { textStyle: { color: PG.neutral400, fontFamily: 'Space Mono, monospace' } },
  tooltip: {
    backgroundColor: '#000000',
    borderColor: PG.red,
    borderWidth: 1,
    textStyle: { color: PG.white, fontFamily: 'Space Mono, monospace', fontSize: 11 },
  },
  color: [PG.red, PG.amber, PG.emerald, PG.cyan, PG.violet, PG.white],
};
